import { useEffect } from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ConnectedSystemStory } from './components/ConnectedSystemStory';
import { Services } from './components/Services';
import { Work } from './components/Work';
import { Process } from './components/Process';
import { Contact } from './components/Contact';
import { Wordmark } from './components/Wordmark';
import { DemoCapture } from './demos/DemoCapture';

function useScrollReveal(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const items = Array.from(document.querySelectorAll<HTMLElement>('.reveal'));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.dataset.visible = 'true');
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          (entry.target as HTMLElement).dataset.visible = 'true';
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, [enabled]);
}

export default function App() {
  const isDemoCapture = new URLSearchParams(window.location.search).has('demo');
  useScrollReveal(!isDemoCapture);
  if (isDemoCapture) return <DemoCapture />;
  return (
    <div className="site">
      <a className="skip-link" href="#main">Skip to content</a>
      <SiteHeader />
      <main id="main">
        <Hero />
        <ConnectedSystemStory />
        <Services />
        <Work />
        <Process />
        <Contact />
      </main>
      <footer className="site-footer section-shell">
        <a className="wordmark" href="#top" aria-label="Workcrafted home"><Wordmark /></a>
        <nav aria-label="Footer navigation"><a href="#work">Work</a><a href="#services">Services</a><a href="#process">Process</a></nav>
        <p>Custom operational software, automation, integrations, and digital systems.</p>
      </footer>
    </div>
  );
}
